export const environment = {
	production: true,
	baseUrl: 'https://paineisddi.cni.com.br/api-ss-oni/',
	nome: 'ambiente',
};
